"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listImages = void 0;
const listImages = ({ httpClient, }) => ({ page = 1, per_page = 25, tag_name = undefined, type = undefined, user_images = undefined, }) => {
    const path = '/images';
    const query_params = {
        page,
        per_page,
        private: user_images,
        tag_name,
        type,
    };
    const url = `${path}`;
    return httpClient.get(url, { params: query_params });
};
exports.listImages = listImages;
//# sourceMappingURL=list-images.js.map